export default __webpack_public_path__ + "6ed99b2.png";